var exports = {
  "t": "FeaturesSection__gpcI2-",
};

module.exports = exports;
